export default "__VITE_ASSET__D7J3SL98__"